import { Box, Typography, Chip, LinearProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PeopleIcon from "@mui/icons-material/People";
import PersonIcon from "@mui/icons-material/Person";
import { MAX_WORK_HOURS } from "../../../../utils/constants";
import { ExpandableSection } from "./ExpandableSection";

type HoursPerUserProps = {
    users: Array<{ name: string; color: string; totalHours: number }>;
    expanded: boolean;
    onChange: (expanded: boolean) => void;
};

export const HoursPerUser = ({ users, expanded, onChange }: HoursPerUserProps) => {
    const theme = useTheme();

    return (
        <ExpandableSection
            title="Por Colaborador"
            icon={<PeopleIcon sx={{ color: theme.palette.primary.main, fontSize: 20 }} />}
            expanded={expanded}
            onChange={onChange}
            hasMarginBottom
        >
            <Box display="flex" flexDirection="column" gap={2}>
                {users.map((item) => {
                    const progressValue = Math.min((item.totalHours / MAX_WORK_HOURS.week) * 100, 100);
                    const isOverLimit = item.totalHours > MAX_WORK_HOURS.week;

                    return (
                        <Box key={item.name} sx={{ mb: 2 }}>
                            <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.5}>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <PersonIcon sx={{ fontSize: 16, color: theme.palette.text.secondary }} />
                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                        {item.name}
                                    </Typography>
                                </Box>
                                <Chip
                                    label={`${item.totalHours}h`}
                                    size="small"
                                    sx={{
                                        bgcolor: isOverLimit
                                            ? theme.palette.error.main
                                            : theme.palette.primary.main,
                                        color: "white",
                                        fontSize: "0.75rem",
                                        height: 24,
                                    }}
                                />
                            </Box>
                            <LinearProgress
                                variant="determinate"
                                value={progressValue}
                                sx={{
                                    height: 6,
                                    borderRadius: 3,
                                    bgcolor: theme.palette.grey[200],
                                    "& .MuiLinearProgress-bar": {
                                        bgcolor: isOverLimit
                                            ? theme.palette.error.main
                                            : theme.palette.primary.main,
                                        borderRadius: 3,
                                    },
                                }}
                            />
                        </Box>
                    );
                })}
            </Box>
        </ExpandableSection>
    );
};
